import useAnchorPassSectionObserver from '~hooks/pass/useAnchorPassSectionObserver';

import PassBanner from './Pass/PassBanner';
import PassHeader from './Pass/PassHeader';
import PassSectionList from './Pass/PassSectionList';

const PassTabContent = () => {
  const { subscribe, scrollTo, inViewSectionKey } = useAnchorPassSectionObserver();

  return (
    <>
      <PassBanner />
      <PassHeader scrollTo={scrollTo} inViewSectionKey={inViewSectionKey} />
      <PassSectionList subscribe={subscribe} />
    </>
  );
};

export default PassTabContent;
